const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Maestro24 = function Maestro24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M8.05 19.6v-1.02a.6.6 0 0 0-.174-.465.614.614 0 0 0-.469-.178.638.638 0 0 0-.577.29.604.604 0 0 0-.543-.29.545.545 0 0 0-.48.241v-.2H5.45V19.6h.36v-.9a.376.376 0 0 1 .098-.31.385.385 0 0 1 .304-.12c.237 0 .357.152.357.427v.902h.36V18.7a.38.38 0 0 1 .1-.308.389.389 0 0 1 .303-.123c.244 0 .36.153.36.428v.902h.359zm2.01-.81v-.81h-.361v.197a.624.624 0 0 0-.515-.238.853.853 0 0 0-.833.849c0 .46.369.835.833.849.2.007.392-.081.515-.238v.197h.357l.004-.806zm-1.328 0a.494.494 0 0 1 .514-.462c.27.01.482.231.478.498a.494.494 0 0 1-.493.483.494.494 0 0 1-.367-.15.483.483 0 0 1-.135-.37h.003zm8.957-.85c.117 0 .234.023.343.065.21.082.378.244.465.45a.89.89 0 0 1 0 .68.825.825 0 0 1-.465.45.982.982 0 0 1-.703 0 .833.833 0 0 1-.462-.45.892.892 0 0 1 0-.68.833.833 0 0 1 .46-.45.934.934 0 0 1 .358-.07l.004.006zm0 .34a.536.536 0 0 0-.204.037.48.48 0 0 0-.272.277.583.583 0 0 0 0 .422.478.478 0 0 0 .272.276.563.563 0 0 0 .578-.106.492.492 0 0 0 .109-.17.583.583 0 0 0 0-.422.494.494 0 0 0-.11-.17.492.492 0 0 0-.17-.107.537.537 0 0 0-.206-.047l.003.01zm-5.69.51c0-.51-.32-.85-.777-.85a.86.86 0 0 0-.738.436.841.841 0 0 0 .012.849.86.86 0 0 0 .75.414c.244.007.484-.074.671-.228l-.17-.262a.787.787 0 0 1-.479.17.454.454 0 0 1-.49-.398h1.216c.006-.041.006-.084.006-.132zm-1.22-.143a.42.42 0 0 1 .431-.392.405.405 0 0 1 .415.393l-.846-.001zm2.723-.255a1.067 1.067 0 0 0-.515-.14c-.196 0-.313.073-.313.192 0 .118.124.138.278.159l.172.023c.357.052.573.201.573.486 0 .286-.274.53-.746.53a1.193 1.193 0 0 1-.71-.21l.172-.276c.158.116.35.176.546.17.244 0 .375-.071.375-.197 0-.091-.093-.142-.289-.17l-.171-.024c-.368-.05-.567-.213-.567-.478 0-.323.268-.52.687-.52a1.24 1.24 0 0 1 .667.17l-.16.285zm1.717-.091h-.583v.732c0 .169.059.272.238.272a.665.665 0 0 0 .315-.093l.103.303a.839.839 0 0 1-.446.125c-.422 0-.57-.224-.57-.6v-.74h-.333v-.322h.333v-.493h.36v.493h.583v.322zm1.234-.364c.086 0 .173.015.254.044l-.11.34a.585.585 0 0 0-.223-.04c-.233 0-.344.149-.344.417v.908h-.357v-1.621h.354v.197a.485.485 0 0 1 .433-.238l-.008-.007h.001zm2.468 1.427c.044 0 .087.015.12.045a.157.157 0 0 1-.054.262.162.162 0 0 1-.066.013.171.171 0 0 1-.154-.098.158.158 0 0 1 .036-.177.173.173 0 0 1 .11-.045h.008zm0 .287a.123.123 0 0 0 .09-.037.124.124 0 0 0 .029-.137.13.13 0 0 0-.209-.04.124.124 0 0 0 0 .169.127.127 0 0 0 .09.038v.007zm.01-.203c.017 0 .033.005.045.014a.04.04 0 0 1 .015.035.038.038 0 0 1-.01.032.06.06 0 0 1-.037.014l.05.057h-.04l-.046-.057h-.016v.057h-.032v-.157l.072.005zm-.036.03v.04h.037a.037.037 0 0 0 .02 0 .017.017 0 0 0 0-.015.017.017 0 0 0 0-.016.037.037 0 0 0-.02 0l-.037-.01z",
      fill: "#000",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M9.296 5.61h5.408v9.608H9.296V5.61z",
      fill: "#7673C0",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M9.64 10.414A6.078 6.078 0 0 1 12 5.607c-2.534-1.97-6.173-1.683-8.36.659a6.064 6.064 0 0 0 0 8.294c2.187 2.342 5.826 2.629 8.36.66a6.078 6.078 0 0 1-2.36-4.806z",
      fill: "#EB001B",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M21.999 10.414a6.107 6.107 0 0 1-3.48 5.495A6.237 6.237 0 0 1 12 15.22a6.089 6.089 0 0 0 2.361-4.806c0-1.876-.87-3.647-2.361-4.806a6.237 6.237 0 0 1 6.52-.692A6.107 6.107 0 0 1 22 10.412l-.001.002z",
      fill: "#00A1DF",
    })
  );
};
Maestro24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
var Maestro32 = function Maestro32(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("rect", {
      x: ".5",
      y: ".5",
      width: "31",
      height: "23",
      rx: "3.5",
      fill: "#fff",
      stroke: "#CCC",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M12.051 19.6v-1.02a.6.6 0 0 0-.175-.465.614.614 0 0 0-.468-.178.638.638 0 0 0-.578.29.604.604 0 0 0-.543-.29.545.545 0 0 0-.48.241v-.2H9.45V19.6h.36v-.9a.376.376 0 0 1 .098-.31.385.385 0 0 1 .304-.12c.237 0 .357.152.357.427v.902h.36V18.7a.38.38 0 0 1 .1-.308.389.389 0 0 1 .303-.123c.244 0 .36.153.36.428v.902h.359zm2.009-.81v-.81h-.361v.197a.624.624 0 0 0-.515-.238.853.853 0 0 0-.833.849c0 .46.369.835.833.849.2.007.392-.081.515-.238v.197h.357l.004-.806zm-1.328 0a.494.494 0 0 1 .514-.462c.27.01.482.231.478.498a.494.494 0 0 1-.493.483.494.494 0 0 1-.367-.15.482.482 0 0 1-.135-.37h.004zm8.957-.85c.117 0 .234.023.343.065.21.082.378.244.465.45a.89.89 0 0 1 0 .68.826.826 0 0 1-.465.45.982.982 0 0 1-.703 0 .833.833 0 0 1-.462-.45.892.892 0 0 1 0-.68.833.833 0 0 1 .461-.45.934.934 0 0 1 .357-.07l.004.006zm0 .34a.535.535 0 0 0-.204.037.48.48 0 0 0-.272.277.583.583 0 0 0 0 .422.478.478 0 0 0 .272.276.563.563 0 0 0 .578-.106.492.492 0 0 0 .109-.17.583.583 0 0 0 0-.422.494.494 0 0 0-.109-.17.49.49 0 0 0-.171-.107.537.537 0 0 0-.206-.047l.003.01zm-5.69.51c0-.51-.319-.85-.777-.85a.86.86 0 0 0-.738.436.841.841 0 0 0 .013.849.86.86 0 0 0 .75.414c.243.007.483-.074.67-.228l-.17-.262a.787.787 0 0 1-.478.17.454.454 0 0 1-.491-.398h1.217c.005-.041.005-.084.005-.132zm-1.22-.143a.42.42 0 0 1 .431-.392.405.405 0 0 1 .416.393l-.847-.001zm2.723-.255a1.066 1.066 0 0 0-.515-.14c-.196 0-.312.073-.312.192 0 .118.123.138.277.159l.172.023c.357.052.573.201.573.486 0 .286-.274.53-.746.53a1.193 1.193 0 0 1-.71-.21l.172-.276c.158.116.35.176.547.17.243 0 .374-.071.374-.197 0-.091-.093-.142-.289-.17l-.171-.024c-.368-.05-.567-.213-.567-.478 0-.323.268-.52.687-.52a1.24 1.24 0 0 1 .667.17l-.16.285zm1.717-.091h-.583v.732c0 .169.06.272.238.272a.665.665 0 0 0 .315-.093l.104.303a.84.84 0 0 1-.447.125c-.422 0-.57-.224-.57-.6v-.74h-.333v-.322h.333v-.493h.36v.493h.583v.322zm1.234-.364c.086 0 .173.015.254.044l-.11.34a.585.585 0 0 0-.223-.04c-.233 0-.343.149-.343.417v.908h-.357v-1.621h.353v.197a.485.485 0 0 1 .433-.238l-.008-.007h.001zm2.469 1.427c.044 0 .086.015.119.045a.157.157 0 0 1-.054.262.162.162 0 0 1-.065.013.171.171 0 0 1-.155-.098.158.158 0 0 1 .036-.177.173.173 0 0 1 .11-.045h.009zm0 .287a.123.123 0 0 0 .089-.037.124.124 0 0 0 .029-.137.13.13 0 0 0-.209-.04.124.124 0 0 0 0 .169.127.127 0 0 0 .09.038v.007zm.01-.203a.08.08 0 0 1 .045.014c.01.01.016.022.014.035a.038.038 0 0 1-.01.032.06.06 0 0 1-.037.014l.05.057h-.04l-.046-.057h-.016v.057h-.032v-.157l.072.005zm-.037.03v.04h.037a.037.037 0 0 0 .02 0 .017.017 0 0 0 0-.015.017.017 0 0 0 0-.016.037.037 0 0 0-.02 0l-.037-.01z",
      fill: "#000",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M13.296 5.61h5.408v9.608h-5.408V5.61z",
      fill: "#7673C0",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M13.64 10.414A6.078 6.078 0 0 1 16 5.607c-2.534-1.97-6.173-1.683-8.36.659a6.064 6.064 0 0 0 0 8.294c2.187 2.342 5.826 2.629 8.36.66a6.079 6.079 0 0 1-2.36-4.806z",
      fill: "#EB001B",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M25.999 10.414a6.107 6.107 0 0 1-3.48 5.495A6.237 6.237 0 0 1 16 15.22a6.089 6.089 0 0 0 2.361-4.806c0-1.876-.87-3.647-2.361-4.806a6.237 6.237 0 0 1 6.52-.692A6.107 6.107 0 0 1 26 10.412l-.001.002z",
      fill: "#00A1DF",
    })
  );
};
Maestro32.defaultProps = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: Maestro24,
  32: Maestro32,
};
export function Maestro(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Maestro' icon. Please use one of the available sizes: '24', '32'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
